import { Box } from '@mantine/core';
import { useAppContainerContext } from './AppContainerContext';
import { SIDEBAR_MODE } from './types';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  bgWidth?: string;
  paneWidth?: string;
  shouldTransition?: boolean;
};

export function AppSidebar({ children, style, bgWidth, paneWidth, shouldTransition }: Props) {
  const { mode } = useAppContainerContext();

  const defaultWidth = mode === SIDEBAR_MODE.standard ? '430px' : '50%';

  return (
    <Box
      h="100%"
      w={bgWidth || defaultWidth}
      pos="relative"
      display="flex"
      style={{
        backgroundColor: 'rgba(255, 119, 28, 0.4)',
        borderRadius:
          'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
        transition: shouldTransition ? 'width 0.2s ease-out' : 'none',
        justifyContent: 'end',
        ...style,
      }}
    >
      <Box
        h="100%"
        w={paneWidth || '100%'}
        pos="relative"
        style={{
          borderRadius:
            'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          overflow: 'hidden',
          transition: shouldTransition ? 'width 0.2s ease-out' : 'none',
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
          }}
        >
          <source src="/sidebar-background.mp4" type="video/mp4" />
        </video>

        <Box
          pos="absolute"
          style={{
            inset: 0,
            backgroundColor: 'rgba(255, 119, 28, 0.7)',
            zIndex: 1,
          }}
        />

        <Box
          pos="relative"
          h="100%"
          px="xl"
          py="xxxl"
          style={{
            zIndex: 2,
            padding: 'var(--mantine-spacing-xxxl) var(--mantine-spacing-xl)',
            overflow: 'auto',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
